<!--
* UIID: UI-DLB-MIG-110
* UI Name: Add Reference File
* Modify Date: 2020/08/14
-->
<template>
  <dialog-drag
    :id="id"
    :ref='"dialog-" + id'
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display add-map-layout-dialog custom-add-map-layout-dialog"
  >
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title
        class="headline white--text"
        primary-title>
         {{options.item.action != 'add' ? $t('lbl.referenceFiles.modifyReferenceFile.pageHeader') : $t('lbl.referenceFiles.addReferenceFile.pageHeader')}}
      </v-card-title>
    </template>
    <template v-slot:button-close>
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>    
    </template>
    <v-card class="dialog-container">
      <!-- [S]  Popup body-->
      <v-card-text class="pb-0">
        <!-- 203705_Reference File List (UI-DLB-RF-100)_Fix Issues 3,4 -->
        <v-form ref="form" class="dialog-content">
          <v-row v-if="options.item.action == 'add'" class="ml-0 mr-0">
            <v-col class="required-col field-col  pt-0" lg="2">
              <v-icon  x-small>fas fa-asterisk</v-icon>
              <span class="field-label required-text">
                {{$t('lbl.referenceFiles.addReferenceFile.fileName')}}
              </span>
            </v-col>
            <v-col class="map-text-field  inline-block-component pl-0  pt-0">
              <v-text-field
                v-model="referenceSaveItemsParams.data[0].ATF_FILE_NAME"
                :rules="[validationUtils.required]"
                class="data-table-filter-text-field inline-block-component text-field-flatfile-layout flatfile-textfield"
                ref="refFileName"
                heigth="30"
                outlined
                dense
                solo
                readonly
              ></v-text-field>
              <input
                @change="browersReferenceFile()"
                id="add_reference_file"
                type="file"
                ref="file"
                style="display: none"
              >
              <!-- <v-btn class="btn-pdf" v-if="checkPdfExtension()" small text icon >
                <v-icon  color="#0082BA" @click="previewPDFFile()" small>fas fa-search-plus</v-icon>
              </v-btn> -->
              <v-btn class="btn btn-popup-search" color="primary" @click="$refs.file.click()">
                {{$t('btn.common.browse')}}
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="options.item.action != 'add'" class="ml-0 mr-0">
            <v-col class="not-required-col field-col pl-0 pt-0" lg="2">
              <span class="field-label required-text">
                {{$t('lbl.referenceFiles.addReferenceFile.fileName')}}
              </span>
            </v-col>
            <v-col lg="10" class="map-text-field pl-0 pt-0">
              <a class="link-file-name" @click="downloadReferenceFile()">{{ referenceSaveItemsParams.data[0].ATF_FILE_NAME }}</a>
            </v-col>
          </v-row>
          <v-row class="ml-0 mr-0">
            <v-col class="required-col field-col" lg="2">
              <v-icon  x-small>fas fa-asterisk</v-icon>
              <span class="field-label required-text">
                {{$t('lbl.referenceFiles.addReferenceFile.docType')}}
              </span>
            </v-col>
            <v-col lg="10" class="map-text-field pl-0">
              <v-select
                v-model="referenceSaveItemsParams.data[0].ATF_FRMT_TP"
                :items="documentType"
                :rules="[validationUtils.required]"
                class="data-table-select-box srm-select-box custom-selectbox flatfile-layout-selectbox communication-select-box pt-0 pl-select"
                ref="refType"
                height="30"
                dense
                solo
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="ml-0 mr-0">
            <v-col class="required-col field-col" lg="2">
              <v-icon  x-small>fas fa-asterisk</v-icon>
              <span class="field-label required-text">
                {{$t('lbl.referenceFiles.addReferenceFile.comment')}}
              </span>
            </v-col>
            <v-col lg="10" class="map-text-field pl-0">
              <v-text-field
                v-model="referenceSaveItemsParams.data[0].ATF_CHKIN_COMT"
                :rules="[validationUtils.required]"
                class="data-table-select-box srm-select-box custom-selectbox flatfile-layout-selectbox communication-select-box pt-0 pl-select"
                ref="refComment"
                height="30"
                dense
                solo
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <v-divider class="ml-0 mr-0 divder-popup" inset></v-divider>
        <v-row class="ml-0 mr-0">
          <v-col class="button-col action-col" lg="12">
            <div class="btn-form-control text-right">
              <v-btn class="btn btn-delete btn-popup" @click="removeDialog">
                {{$t('btn.common.close')}}
              </v-btn>
              <v-btn class="btn btn-popup-search btn-popup" color="primary" @click="saveReferenceFile">
                {{$t('btn.common.save')}}
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <!-- <v-row class="ml-0 mr-0">
          <v-col class="button-col action-col" lg="12">
            <div class="btn-form-control text-right mr-4">
              <v-btn class="btn btn-popup-search" color="primary" @click="saveReferenceFile">
                {{$t('btn.common.save')}}
              </v-btn>
              <v-btn class="btn btn-delete" @click="removeDialog">
                {{$t('btn.common.close')}}
              </v-btn>
            </div>
          </v-col>
        </v-row> -->
      </v-card-text>
      <!-- [E]  Popup body-->
    </v-card>
    <!-- <v-dialog v-model="pdfDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{$t('lbl.referenceFiles.addReferenceFile.viewPdfFile')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="pdfDialog = false">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <pdf :url="pdfUrl" />
      </v-card>
    </v-dialog> -->
    <dialogWindow
      ref="successDialog"
      size="max"
      title="Success"
      color="success"
      @select-ok="removeDialog"
      :detail="$t('msg.referenceFiles.addReferenceFile.saveSuccess')"
    ></dialogWindow>
    <!-- 2020/11/11 203737 Remove unused source
    <dialogWindow
      ref="warningDialog"
      size="max"
      title="warning"
      :detail="$t('msg.referenceFiles.addReferenceFile.warningDialog')"
      color="validation"
    ></dialogWindow> -->
  </dialog-drag>
</template>

<script>
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue'
import { mapState } from "vuex";
// import pdf from '../../components/pdf-viewer/pdf.vue'
import IconSvg from "@/vue-caas/components/IconBase.vue";

import {
  showSuccessMessage,
  showErrorMessage,
  showProgress,
  hideProgress,
  alertSuccess,
  closeAlert
} from "@/vue-dlb/utils/sys-util.js";


export default {
  components: {
      DialogDrag,
      dialogWindow,
      // pdf,
      IconSvg,
    },
  name: 'maplist-dialog',
  /* 2020/11/05 203737 Change prop definitions
  props: ['id', 'options', 'closeDialog', 'dragStart', 'dragEnd', 'queryList'],*/
  props:{
      id: String,
      options: Object,
      closeDialog: Function,
      dragStart: Function,
      dragEnd: Function,
  },
  computed: {
    ...mapState("common", {
        codeList: "codeList"
    }),
  },
  data: () => ({
    updateReferenceFileLayoutHeader: {
      header: ['ATF_PRCS_NO','FRMT_TP','CHKIN_COMT'],
      data:[{
        ATF_PRCS_NO:'',
        FRMT_TP:'',
        CHKIN_COMT:'',
      }]
    },
    referenceFileDownloadItems: {
      header: ['FILE_ID','SAVE_NAME'],
      data: [{
        FILE_ID: '',
        SAVE_NAME:''
      }],
    },
    SummDataList: {
      headers: [
        { text: 'Document Type', value: 'ATF_FRMT_TP', width: '200px' },
        { text: 'File Name', value: 'ATF_FILE_NAME' },
        { text: 'Updated Date', value: 'ATF_UPD_DT', width: '170px' },
        { text: 'Manage', value: 'ATF_FILE_PATH', width: '150px' },
      ]
    },
    dialog: false,
    reloadPage: false,
    dialogs: [],
    // pdfDialog: false,
    // pdfUrl :'',
    masterSearchItems: {
      header: ['SRM_PRCS_NO'],
      data: [{
        SRM_PRCS_NO: '',
      }],
    },
    masterSearchItemsRepo: {
      header: ['REPO_PRCS_NO'],
      data: [{
        REPO_PRCS_NO: '',
      }],
    },
    referenceDownloadItems: {
      header: ['FILE_ID','SAVE_NAME'],
      data: [{
        FILE_ID: '',
        SAVE_NAME:''
      }],
    },
    referenceSaveItemsParams:{
      header: ['SYSSTATUS','ADDBY','CUST_ID', 'OWNR_CUST_ID', 'USER_ID','ATF_PRCS_NO','SRM_PRCS_NO','ATF_FRMT_TP','ATF_FILE_NAME','FILE_ID','ATF_FILE_SIZE','ATF_CHKIN_COMT','file'],
      data:[{
        SYSSTATUS:'',
        ADDBY:'',
        CUST_ID:'',
        OWNR_CUST_ID: `${$cookies.get('ownr-id')}`,
        USER_ID:'',
        ATF_PRCS_NO:'',
        SRM_PRCS_NO:'',
        ATF_FRMT_TP:'',
        ATF_FILE_NAME:'',
        FILE_ID:'',
        ATF_FILE_SIZE:'',
        ATF_CHKIN_COMT: '',
        file:'',
      }],
    },
    documentType: [],
    codeSearchItems: {
      header: ['GRP_CODE'],
      data: [{
        GRP_CODE:'',
      }],
    },
  }),
  created() {
   if (this.options.item.action != 'add') {
     let data = this.options.item.data;
     this.referenceSaveItemsParams.data[0].ATF_PRCS_NO = data.ATF_PRCS_NO;
     this.referenceSaveItemsParams.data[0].ATF_FILE_NAME = data.ATF_FILE_NAME;
     this.referenceSaveItemsParams.data[0].ATF_FRMT_TP = data.ATF_FRMT_TP;
     this.referenceSaveItemsParams.data[0].ATF_CHKIN_COMT = data.ATF_CHKIN_COMT;
     this.referenceSaveItemsParams.data[0].FILE_ID =data.FILE_ID;
   }
   this.getCode();
  },
  mounted() {
    setTimeout(() => {
      this.$refs.refComment.focus();
    }, 300);
  },
  methods: {
    getCode(){
      this.codeSearchItems.data[0].GRP_CODE ="B05";
      Store.dispatch("common/getCode", this.codeSearchItems).then(() => {
          console.log("--------- Finished to process code List ----------");
          for(let i=0;i< this.codeList.length;i++){
          let codeObj= {};
          codeObj.text= this.codeList[i].CM_CODE_NAME;
          codeObj.value= this.codeList[i].CM_CODE_ID;
          this.documentType.push(codeObj);
          }
      });
    },
    removeDialog (dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
      if (this.reloadPage) {
        this.$emit("reloadPage");
      }
    },
    selectDialog (obj) {
      this.dragStart(obj);
    },
    dialogDragEnd (obj) {
        this.dragEnd(obj);
    },
    newDialog (item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    browersReferenceFile(e){
      this.referenceSaveItemsParams.data[0].ATF_FILE_NAME = this.$refs.file.files[0].name;
      this.referenceSaveItemsParams.data[0].SYSSTATUS = 'I';
      this.referenceSaveItemsParams.data[0].ADDBY ='LOCAL';
      this.referenceSaveItemsParams.data[0].CUST_ID = $cookies.get('comp-id');
      this.referenceSaveItemsParams.data[0].USER_ID = $cookies.get('user-id');
      this.referenceSaveItemsParams.data[0].ATF_PRCS_NO = '';
      this.referenceSaveItemsParams.data[0].SRM_PRCS_NO = '';
      this.referenceSaveItemsParams.data[0].FILE_ID = '';
      this.referenceSaveItemsParams.data[0].ATF_CHKIN_COMT = '';
      this.referenceSaveItemsParams.data[0].ATF_FILE_SIZE = this.$refs.file.files[0].size;
      this.referenceSaveItemsParams.data[0].file = this.$refs.file.files[0] ;
    },
    // checkPdfExtension() {
    //   let file = this.referenceSaveItemsParams.data[0].ATF_FILE_NAME;
    //   let extension = file.substr(file.lastIndexOf('.') + 1);
    //   if (extension == 'pdf') {
    //     return true;
    //   }
    //   return false;
    // },
    // previewPDFFile() {
    //   let blob = this.referenceSaveItemsParams.data[0].file;
    //   this.pdfDialog = true;
    //   this.pdfUrl = window.URL.createObjectURL(blob);
    // },
    downloadReferenceFile (){
      this.referenceFileDownloadItems.data[0].FILE_ID =  this.referenceSaveItemsParams.data[0].FILE_ID;
      this.referenceFileDownloadItems.data[0].SAVE_NAME =  this.referenceSaveItemsParams.data[0].ATF_FILE_NAME;
      Store.dispatch("common/DownloadFileFromServer", this.referenceFileDownloadItems).then(() => {
        console.log("--------- Finished to process ----------");
      });
    },
    saveReferenceFile(){
      let validResult = this.$refs.form.validate();
      if (validResult) {
        if (this.options.item.action == 'add') {
          if(this.referenceSaveItemsParams.data.length > 0){
              Store.dispatch("referencefile/saveAddReferenceFiles", this.referenceSaveItemsParams).then(() => {
                console.log("--------- Finished to process ----------");
                this.reloadPage = true;
                this.$refs.successDialog.dialog = true;
            });
          }
      } else {
          this.updateReferenceFileLayoutHeader.data[0].ATF_PRCS_NO = this.referenceSaveItemsParams.data[0].ATF_PRCS_NO;
          this.updateReferenceFileLayoutHeader.data[0].FRMT_TP = this.referenceSaveItemsParams.data[0].ATF_FRMT_TP;
          this.updateReferenceFileLayoutHeader.data[0].CHKIN_COMT = this.referenceSaveItemsParams.data[0].ATF_CHKIN_COMT;
          Store.dispatch("referencefile/modifyReferenceFiles", this.updateReferenceFileLayoutHeader).then(() => {
            console.log("--------- Finished to process ----------");
            this.reloadPage = true;
            this.$refs.successDialog.dialog = true;
          });
        }
      } else {
        if (!this.$refs.refType.validate()) {
          this.$refs.refType.focus();
        } else if(!this.$refs.refComment.validate()){
          this.$refs.refComment.focus();
        }
        return validResult;
      }
    },
  },
}
</script>
<style>
/* .btn-pdf{
  margin-left: -6%;
  margin-right: 10px;
} */
.link-file-name{
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  display: flex;
  text-decoration-line: underline;
}
</style>